class CountDown extends HTMLElement {
  constructor() {
    super();

    if (
     this.dataset.enabled === 'false' ||
     this.dataset.day === '' ||
     this.dataset.month === '' ||
     this.dataset.year === ''
      ) {
        return;
    }

    this.container = this.querySelector('.countdown');
    
    this.dst = this.dataset.dst;
    console.log('this.dst', this.dst)
    this.headingEl = this.querySelector('.countdown__heading')
    this.dayEl = this.querySelector('[data-countdown-day]');
    this.hourEl = this.querySelector('[data-countdown-hour]');
    this.minuteEl = this.querySelector('[data-countdown-minute]');
    this.secondEl = this.querySelector('[data-countdown-second]');
    
    this.init(this.dataset);
  }

  init(endTime) {
    this.headingEl.textContent = this.dataset.heading;

    const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log({ clientTimezone })

    let timeInterval = setInterval(() => {
      let localEndTime = this.changeTimeZone(
        `${endTime.month}/${endTime.day}/${endTime.year} ${endTime.hour}:${endTime.minutes}`,
        clientTimezone
      );
      let time = this.getTimeRemaining(localEndTime);

      this.dayEl.textContent = time.days;
      this.hourEl.textContent = time.hours;
      this.minuteEl.textContent = time.minutes;
      this.secondEl.textContent = ('0' + time.seconds).slice(-2);

      if (time.total <= 0) {
        this.container.classList.add('hidden');
        clearInterval(timeInterval);
      } else {
        this.container.classList.remove('hidden');
      }
    }, 1000);
  }

  changeTimeZone(date) {
    const userTime = new Date(date);
    let adelaideOffsetHour;

    if (this.dst == 'true') {
      adelaideOffsetHour = 10.5;
    } else {
      adelaideOffsetHour = 9.5;
    }

    const adelaideOffset = adelaideOffsetHour * 60 * 60 * 1000;
    return userTime.getTime() - adelaideOffset;
  }

  getTimeRemaining(localEndTime) {
    const utcNow = new Date(new Date().getTime() + (new Date().getTimezoneOffset() * 60000));
    var time = localEndTime - utcNow;
    var seconds = Math.floor((time / 1000) % 60);
    var minutes = Math.floor((time / 1000 / 60) % 60);
    var hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    var days = Math.floor(time / (1000 * 60 * 60 * 24));
    return {
      total: time,
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    };
  }
}

customElements.define('count-down', CountDown);